export type DatelineLocale = 'en' | 'de' | 'fr';

const MONTHS: Record<DatelineLocale, readonly string[]> = {
    en: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    de: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
    fr: ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'],
};

const LEAD: Record<DatelineLocale, string> = {
    en: 'Page last reviewed',
    de: 'Seite zuletzt geprüft',
    fr: 'Dernière vérification',
};

const BYLINE = 'pdfmarkuptool.com / Small Tiger Group';

/** "Page last reviewed: October 2026 -- pdfmarkuptool.com / Small Tiger Group" for a YYYY-MM-DD date. */
export function datelineText(reviewed: string, locale: DatelineLocale = 'en'): string {
    const [year, month] = reviewed.split('-');
    const monthName = MONTHS[locale][Number(month) - 1];
    if (!year || !monthName) throw new Error(`Dateline needs a YYYY-MM-DD date, got: ${reviewed}`);
    const sep = locale === 'fr' ? '\u00a0: ' : ': ';
    return `${LEAD[locale]}${sep}${monthName} ${year} -- ${BYLINE}`;
}

export interface DatelineProps {
    /** The page's content date (registry `reviewed`, YYYY-MM-DD). */
    reviewed: string;
    locale?: DatelineLocale;
}

/**
 * The visible "Page last reviewed" line at the foot of a marketing page. Reads the page
 * registry's `reviewed` date, the same date the sitemap's <lastmod> carries.
 */
export function Dateline({ reviewed, locale = 'en' }: DatelineProps) {
    return (
        <section className="mktg-context">
            <div className="mktg-container">
                <p className="mktg-context__note">
                    <time dateTime={reviewed} data-testid="page-dateline">{datelineText(reviewed, locale)}</time>
                </p>
            </div>
        </section>
    );
}
